import { render, staticRenderFns } from "./ImageGallery.vue?vue&type=template&id=6258905c&scoped=true"
import script from "./ImageGallery.vue?vue&type=script&lang=ts"
export * from "./ImageGallery.vue?vue&type=script&lang=ts"
import style0 from "./ImageGallery.vue?vue&type=style&index=0&id=6258905c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6258905c",
  null
  
)

export default component.exports